module.exports = __webpack_public_path__ + "0109bc4c8989544dc1a970be6b8a66a6.jpg";